<template>
    <van-popup v-model="visible" position="bottom" round :style="{ height: '85%' }" @close="onClose">
        <div class="shipment_dialog">
            <!-- 头部 -->
            <div class="dialog_header">
                <span class="dialog_title">新增发货</span>
                <van-icon name="cross" size="22" color="#999" @click="close" />
            </div>

            <!-- 已选产品/物料列表 + 表单整体滚动 -->
            <div class="dialog_scrollable">
            <!-- 发货类型切换 -->
            <div class="type_switch_row">
                <span class="type_btn" :class="{ active: currentType === 'product' }" @click="switchType('product')">产品</span>
                <span class="type_btn" :class="{ active: currentType === 'material' }" @click="switchType('material')">物料</span>
            </div>
            <div class="selected_items" v-if="selectedItems.length > 0">
                <div class="sel_title">已选 {{selectedItems.length}} 项</div>
                <div class="sel_list">
                    <div class="sel_item" v-for="(item, idx) in selectedItems" :key="item.id">
                        <div class="sel_info">
                            <span class="sel_name">{{item.name}}</span>
                            <span class="sel_code">{{item.code}}</span>
                            <div class="sel_stock_row">
                                <span class="sel_stock">{{formData_stock_name}}库存: {{item.warehouse_stock !== undefined ? item.warehouse_stock : item.stock_num}}</span>
                            </div>
                        </div>
                        <div class="sel_qty">
                            <van-stepper v-model="item.shipment_num" :min="1" :max="item.warehouse_stock || item.stock_num || 9999" theme="round" button-size="28px" />
                            <van-icon name="cross" size="16" color="#ccc" class="sel_remove" @click="removeItem(idx)" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 添加产品/物料按钮 -->
            <div class="add_item_row" @click="openRecordPicker">
                <van-icon name="plus" size="16" color="#4E89FF" />
                <span>添加{{shipmentTypeText}}</span>
            </div>

            <!-- 表单 -->
            <div class="dialog_form">
                <!-- 仓库切换 -->
                <div class="warehouse_row" v-if="warehouseList.length > 0">
                    <span class="wh_label">发货仓库</span>
                    <div class="wh_tags">
                        <span class="wh_btn" v-for="wh in warehouseList" :key="wh.stock_code"
                            :class="{ active: formData_stock_code === String(wh.stock_code) }"
                            @click="selectWarehouse(wh)">
                            {{wh.stock_name}}
                            <b v-if="formData_stock_code === String(wh.stock_code)">●</b>
                        </span>
                    </div>
                </div>
                <van-field
                    v-model="formData.studio_name"
                    type="select"
                    label="项目"
                    placeholder="请选择项目"
                    readonly
                    @click="showStudioSelect = true"
                    is-link
                    required
                />
                <van-field
                    v-model="formData.sale_user_name"
                    type="select"
                    label="销售人员"
                    placeholder="请选择"
                    readonly
                    @click="showSaleUserSelect = true"
                    is-link
                    required
                />
                <van-field
                    v-model="addressText"
                    rows="4"
                    type="textarea"
                    label="收货信息"
                    placeholder="姓名 手机号 收货地址，空格或换行分隔"
                    clearable
                    required
                    autosize
                />
                <van-field
                    v-model="formData.remark"
                    type="textarea"
                    rows="2"
                    label="备注"
                    placeholder="选填"
                    autosize
                />
            </div>
            </div><!-- end dialog_scrollable -->

            <!-- 提交按钮 -->
            <div class="dialog_footer">
                <van-button type="primary" block round :loading="submitting" :disabled="submitting" loading-text="提交中..." @click="onSubmit">
                    提交发货 ({{selectedItems.length}}项)
                </van-button>
            </div>

            <!-- 产品/物料选择弹窗 -->
            <van-popup v-model="showRecordPicker" position="bottom" round :style="{ height: '88%' }">
                <div class="record_picker">
                    <div class="picker_header">
                        <span>选择{{shipmentTypeText}}</span>
                        <van-icon name="cross" size="20" color="#999" @click="showRecordPicker = false" />
                    </div>
                    <van-search v-model="recordSearchKey" placeholder="搜索名称/编码" shape="round" @change="filterRecords" />
                    <div class="record_list">
                        <div class="record_option" v-for="item in filteredRecords" :key="item.id"
                            :class="{ checked: isSelected(item.id), disabled: getItemWarehouseStock(item) <= 0 }"
                            @click="toggleSelect(item)">
                            <van-icon :name="isSelected(item.id) ? 'success' : 'circle'" 
                                :color="isSelected(item.id) ? '#4E89FF' : (getItemWarehouseStock(item) <= 0 ? '#ddd' : '#ccc')" size="20" />
                            <div class="ro_img" v-if="getFirstImg(item.imgs)" @click.stop="previewImage(item.imgs)">
                                <img :src="getFirstImg(item.imgs)" />
                                <span v-if="getImgCount(item.imgs) > 1" class="ro_img_count">{{ getImgCount(item.imgs) }}图</span>
                            </div>
                            <div class="ro_info">
                                <div class="ro_top">
                                    <span class="ro_name">{{item.name}}</span>
                                    <span class="ro_stock" :class="{ low: getItemWarehouseStock(item) <= 0, warn: getItemWarehouseStock(item) > 0 && getItemWarehouseStock(item) < 10 }">{{getItemWarehouseStock(item)}}</span>
                                </div>
                                <span class="ro_code">{{item.code}}</span>
                                <div class="ro_warehouse" v-if="item.stock_num_info && item.stock_num_info.length">
                                    <span class="ro_wh_tag" v-for="(wh, idx) in item.stock_num_info" :key="idx"
                                        :style="{ borderColor: String(wh.stock_code) === formData_stock_code ? '#4E89FF' : '' }">
                                        {{wh.stock_name}} <b :style="{color: wh.StockNum > 0 ? '#4CAF50' : '#ccc'}">{{wh.StockNum}}</b>
                                    </span>
                                </div>
                                <span class="ro_no_stock" v-if="getItemWarehouseStock(item) <= 0">{{formData_stock_name}}库存不足，不可发货</span>
                            </div>
                        </div>
                        <div class="empty_records" v-if="filteredRecords.length === 0">
                            <span>暂无数据</span>
                        </div>
                    </div>
                    <div class="picker_footer">
                        <van-button type="primary" size="small" round @click="showRecordPicker = false">
                            确定 ({{selectedItems.length}})
                        </van-button>
                    </div>
                </div>
            </van-popup>

            <!-- 项目选择器 -->
            <van-popup v-model="showStudioSelect" position="bottom" round>
                <van-picker
                    ref="studioPicker"
                    show-toolbar
                    :columns="studioColumns"
                    value-key="text"
                    @confirm="onStudioConfirm"
                    @cancel="showStudioSelect = false"
                />
            </van-popup>

            <!-- 销售人员选择器 -->
            <van-popup v-model="showSaleUserSelect" position="bottom" round>
                <van-picker
                    ref="saleUserPicker"
                    show-toolbar
                    :columns="saleUserColumns"
                    value-key="text"
                    @confirm="onSaleUserConfirm"
                    @cancel="showSaleUserSelect = false"
                />
            </van-popup>
        </div>
    </van-popup>
</template>

<script>
import studio_api from '@/api/teaching_studio_teaching_studio_api.js'
import studio_tool_api from '@/api/teaching_studio_tool.js'
import { get } from '@/api/getpost.js'
import until from '@/api/until.js'
import { ImagePreview } from 'vant'

export default {
    name: 'ShipmentDialog',
    props: {
        value: Boolean,           // v-model 控制显示隐藏
        shipmentType: String,     // 'product' | 'material'（初始类型）
        preselectedItems: Array,  // 预选中的产品/物料 [{id, name, code, stock_num}]
        userInfo: Object          // 当前用户信息
    },
    data() {
        return {
            visible: false,
            submitting: false,
            currentType: 'product', // 当前选中的发货类型
            selectedItems: [],    // [{id, name, code, stock_num, shipment_num}]
            addressText: '',
            formData: {
                studio_id: '',
                studio_name: '',
                sale_user_id: '',
                sale_user_name: '',
                remark: ''
            },
            // 仓库
            warehouseList: [],
            formData_stock_code: '',
            formData_stock_name: '',
            // 选项数据
            allRecords: [],
            filteredRecords: [],
            recordSearchKey: '',
            showRecordPicker: false,
            showStudioSelect: false,
            showSaleUserSelect: false,
            studioColumns: [],
            saleUserColumns: [],
            studiosRaw: [],
            saleUsersRaw: []
        }
    },
    computed: {
        shipmentTypeText() {
            return this.currentType === 'material' ? '物料' : '产品'
        }
    },
    watch: {
        value(val) {
            this.visible = val
            if (val) this.onOpen()
        },
        visible(val) {
            if (!val) this.$emit('input', false)
        }
    },
    methods: {
        // 弹窗打开
        async onOpen() {
            // 初始化发货类型
            this.currentType = this.shipmentType || 'product'
            // 初始化选中项
            if (this.preselectedItems && this.preselectedItems.length > 0) {
                this.selectedItems = this.preselectedItems.map(item => ({
                    id: item.id,
                    name: item.name,
                    code: item.code,
                    stock_num: item.stock_num || 0,
                    stock_num_info: item.stock_num_info || [],
                    shipment_num: 1
                }))
            } else {
                this.selectedItems = []
            }
            this.addressText = ''
            this.formData.remark = ''
            this.formData.studio_id = ''
            this.formData.studio_name = ''
            this.formData.sale_user_id = ''
            this.formData.sale_user_name = ''
            this.formData_stock_code = ''
            this.formData_stock_name = ''
            this.recordSearchKey = ''

            // 加载选项数据和产品/物料列表
            this.loadWarehouseList()
            this.loadStudios()
            this.loadSaleUsers()
            this.loadRecords()
        },

        // 切换发货类型
        switchType(type) {
            if (this.currentType === type) return
            this.currentType = type
            this.selectedItems = []
            this.recordSearchKey = ''
            this.loadRecords()
        },

        // 加载仓库列表，默认当前仓库
        async loadWarehouseList() {
            try {
                let res = await get('/teaching_studio_api/iotmax/stock_list', { app_id: this.$root.app_id })
                if (res && res.errcode === 0 && res.other) {
                    let list = Array.isArray(res.other) ? res.other : []
                    this.warehouseList = list
                    // 默认选当前登录仓库（is_login === 1）
                    let currentWh = list.find(item => item.is_login === 1 || item.is_login === '1')
                    if (currentWh) {
                        this.formData_stock_code = String(currentWh.stock_code)
                        this.formData_stock_name = currentWh.stock_name
                    } else if (list.length > 0) {
                        this.formData_stock_code = String(list[0].stock_code)
                        this.formData_stock_name = list[0].stock_name
                    }
                    // 更新已选项目的仓库库存
                    this.updateSelectedItemsWarehouseStock()
                }
            } catch (e) {
                console.error('获取仓库列表失败', e)
            }
        },

        // 点选仓库
        selectWarehouse(wh) {
            this.formData_stock_code = String(wh.stock_code)
            this.formData_stock_name = wh.stock_name
            // 更新已选项目的仓库库存
            this.updateSelectedItemsWarehouseStock()
        },

        // 获取产品在当前仓库的库存
        getItemWarehouseStock(item) {
            if (!this.formData_stock_code || !item.stock_num_info) return item.stock_num || 0
            let wh = item.stock_num_info.find(w => String(w.stock_code) === String(this.formData_stock_code))
            return wh ? (wh.StockNum || 0) : 0
        },

        // 更新已选项目的仓库库存
        updateSelectedItemsWarehouseStock() {
            this.selectedItems.forEach(item => {
                let whStock = this.getItemWarehouseStock(item)
                item.warehouse_stock = whStock
                // 如果发货数量超过当前仓库库存，自动调整
                if (item.shipment_num > whStock) {
                    item.shipment_num = Math.max(1, whStock)
                }
            })
            // 移除当前仓库库存为0的项目
            this.selectedItems = this.selectedItems.filter(item => {
                if (item.warehouse_stock <= 0) {
                    return false
                }
                return true
            })
        },

        // 加载项目列表，默认选最新
        async loadStudios() {
            try {
                let res = await studio_api.Teaching_studio_apiStudioWechatStudioGet({
                    app_id: this.$root.app_id
                })
                if (res.errcode === 0 && res.other) {
                    let listData = Array.isArray(res.other) ? res.other : (res.other.list || [])
                    // 按 ID 倒序排列，最新的排最前面
                    listData.sort((a, b) => (b.id || 0) - (a.id || 0))
                    this.studiosRaw = listData
                    this.studioColumns = listData.map(item => ({
                        text: `#${item.id} ${item.name}`,
                        value: String(item.id)
                    }))
                    // 默认选最新一个（倒序后第一个）
                    if (listData.length > 0) {
                        this.formData.studio_id = String(listData[0].id)
                        this.formData.studio_name = listData[0].name
                    }
                }
            } catch (e) {
                console.error('获取项目列表失败', e)
            }
        },

        // 加载销售人员列表，默认选当前用户
        async loadSaleUsers() {
            try {
                let res = await studio_api.Teaching_studio_apiIotmaxUsersGet({
                    app_id: this.$root.app_id
                })
                if (res.errcode === 0 && res.other) {
                    let listData = res.other.list || []
                    this.saleUsersRaw = listData
                    this.saleUserColumns = listData.map(item => ({
                        text: item.real_name || item.name,
                        value: String(item.user_id || item.id)
                    }))
                    // 默认选当前用户
                    if (this.userInfo) {
                        let uid = String(this.userInfo.id || this.userInfo.user_id || '')
                        let matched = listData.find(item => String(item.user_id || item.id) === uid)
                        if (matched) {
                            this.formData.sale_user_id = String(matched.user_id || matched.id)
                            this.formData.sale_user_name = matched.real_name || matched.name
                        }
                    }
                }
            } catch (e) {
                console.error('获取用户列表失败', e)
            }
        },

        // 加载产品/物料列表
        async loadRecords() {
            try {
                let res
                if (this.currentType === 'material') {
                    res = await studio_api.Teaching_studio_apiIotmaxMaterialListGet({
                        app_id: this.$root.app_id, page: 1, each_page: 200
                    })
                } else {
                    res = await studio_api.Teaching_studio_apiIotmaxProductListGet({
                        app_id: this.$root.app_id, page: 1, each_page: 200
                    })
                }
                if (res.errcode === 0 && res.other && res.other.list) {
                    this.allRecords = res.other.list
                    // 有库存靠前，无库存靠后
                    this.allRecords.sort((a, b) => ((b.stock_num || 0) > 0 ? 1 : 0) - ((a.stock_num || 0) > 0 ? 1 : 0))
                    this.filteredRecords = [...this.allRecords]
                }
            } catch (e) {
                console.error('获取列表失败', e)
            }
        },

        // 搜索过滤
        filterRecords() {
            let key = this.recordSearchKey.toLowerCase()
            if (!key) {
                this.filteredRecords = [...this.allRecords]
            } else {
                this.filteredRecords = this.allRecords.filter(item =>
                    (item.name || '').toLowerCase().includes(key) ||
                    (item.code || '').toLowerCase().includes(key)
                )
            }
        },

        // 打开选择器
        openRecordPicker() {
            this.recordSearchKey = ''
            this.filterRecords()
            this.showRecordPicker = true
        },

        // 判断是否已选中
        isSelected(id) {
            return this.selectedItems.some(item => item.id === id)
        },

        // 切换选中
        toggleSelect(item) {
            // 优先使用当前仓库库存
            let whStock = this.getItemWarehouseStock(item)
            let stockToUse = this.formData_stock_code ? whStock : (item.stock_num || 0)
            if (stockToUse <= 0) {
                let whName = this.formData_stock_name || '当前仓库'
                this.$toast(`${item.name} 在${whName}库存不足，不可发货`)
                return
            }
            let idx = this.selectedItems.findIndex(s => s.id === item.id)
            if (idx > -1) {
                this.selectedItems.splice(idx, 1)
            } else {
                this.selectedItems.push({
                    id: item.id,
                    name: item.name,
                    code: item.code,
                    stock_num: item.stock_num || 0,
                    stock_num_info: item.stock_num_info || [],
                    warehouse_stock: whStock,
                    shipment_num: 1
                })
            }
        },

        // 移除已选
        removeItem(idx) {
            this.selectedItems.splice(idx, 1)
        },

        // 项目选择确认
        onStudioConfirm() {
            let picker = this.$refs.studioPicker
            if (picker) {
                let values = picker.getValues()
                let item = values[0]
                if (item) {
                    this.formData.studio_id = item.value
                    let nameMatch = item.text.match(/^#\d+\s*(.+)/)
                    this.formData.studio_name = nameMatch ? nameMatch[1] : item.text
                }
            }
            this.showStudioSelect = false
        },

        // 销售人员选择确认
        onSaleUserConfirm() {
            let picker = this.$refs.saleUserPicker
            if (picker) {
                let values = picker.getValues()
                let item = values[0]
                if (item) {
                    this.formData.sale_user_id = item.value
                    this.formData.sale_user_name = item.text
                }
            }
            this.showSaleUserSelect = false
        },

        // 获取第一张图片
        getFirstImg(imgs) {
            if (!imgs) return ''
            return imgs.split(',').map(s => s.trim()).filter(s => s)[0] || ''
        },

        // 获取图片列表
        getImgList(imgs) {
            if (!imgs) return []
            return imgs.split(',').map(s => s.trim()).filter(s => s)
        },

        // 获取图片数量
        getImgCount(imgs) {
            if (!imgs) return 0
            return imgs.split(',').map(s => s.trim()).filter(s => s).length
        },

        // 预览图片
        previewImage(imgs) {
            const list = this.getImgList(imgs)
            if (list.length === 0) return
            ImagePreview({ images: list, closeable: true, closeIconPosition: 'top-right' })
        },

        // 智能解析收货信息，提取姓名、手机号、地址（始终返回结果，不校验）
        parseAddressInfo(text) {
            let name = ''
            let phone = ''
            let address = ''

            if (!text || !text.trim()) return { name, phone, address }

            // 匹配中国大陆手机号：1开头的11位数字
            const phoneRegex = /1[3-9]\d{9}/
            const phoneMatch = text.match(phoneRegex)

            if (phoneMatch) {
                phone = phoneMatch[0]
                const beforePhone = text.substring(0, phoneMatch.index).trim()
                const afterPhone = text.substring(phoneMatch.index + phone.length).trim()

                // 清理前后分隔符
                const nameCandidate = beforePhone.replace(/[,，、\s]+$/g, '').trim()
                const addrCandidate = afterPhone.replace(/^[,，、\s]+/g, '').trim()

                if (nameCandidate && nameCandidate.length <= 10) {
                    // 手机号前有短文本 → 姓名
                    name = nameCandidate
                    address = addrCandidate
                } else if (addrCandidate) {
                    // 手机号前无姓名（或太长），手机号后有内容 → 从中拆分姓名和地址
                    const afterParts = addrCandidate.split(/[,，、\s]+/).filter(s => s.trim())
                    if (afterParts.length >= 2) {
                        name = afterParts[0]
                        address = afterParts.slice(1).join(',').trim()
                    } else if (afterParts.length === 1) {
                        address = afterParts[0]
                    }
                }

                // 如果上面没找到姓名，且前面有内容（太长），尝试拆分
                if (!name && beforePhone) {
                    const beforeParts = beforePhone.split(/[,，、\n\s]+/).filter(s => s.trim())
                    if (beforeParts.length > 0) {
                        name = beforeParts[0].trim()
                        address = beforeParts.slice(1).join(',').trim() || address
                    }
                }
            } else {
                // 没有手机号，尝试从开头提取姓名（2-4个汉字 或 2-10个其他字符）
                const nameMatch = text.match(/^([\u4e00-\u9fa5]{2,4}|[a-zA-Z0-9\s]{2,10})/)
                if (nameMatch) {
                    name = nameMatch[1].trim()
                    const rest = text.substring(nameMatch[0].length).replace(/^[,，、\s]+/g, '').trim()
                    address = rest
                } else {
                    // 按分隔符拆分，第一段为姓名，其余为地址
                    const parts = text.split(/[,，、\n]+/).map(s => s.trim()).filter(s => s)
                    if (parts.length >= 1) {
                        name = parts[0]
                        address = parts.slice(1).join(',').trim()
                    }
                }
            }

            // 无论识别结果如何，始终返回
            return { name, phone, address }
        },

        // 提交
        async onSubmit() {
            // 防止连点
            if (this.submitting) return

            // 校验
            if (this.selectedItems.length === 0) {
                this.$toast('请至少选择一项' + this.shipmentTypeText)
                return
            }
            if (!this.formData_stock_code) {
                this.$toast('请选择发货仓库')
                return
            }
            if (!this.formData.studio_id) {
                this.$toast('请选择项目')
                return
            }
            if (!this.formData.sale_user_id) {
                this.$toast('请选择销售人员')
                return
            }
            let addrText = (this.addressText || '').trim()

            // 校验每个数量（使用当前仓库库存）
            for (let item of this.selectedItems) {
                if (!item.shipment_num || item.shipment_num < 1) {
                    this.$toast(`${item.name} 数量无效`)
                    return
                }
                let whStock = item.warehouse_stock !== undefined ? item.warehouse_stock : (item.stock_num || 0)
                if (item.shipment_num > whStock) {
                    this.$toast(`${item.name} 发货数量(${item.shipment_num})超过${this.formData_stock_name}库存(${whStock})`)
                    return
                }
            }

            // 智能解析收货信息，提取姓名、手机号、地址
            let parsedAddr = this.parseAddressInfo(addrText)
            // 姓名,手机号,地址 用英文逗号拼接，没有识别到的字段留空
            let shipment_address_info = [parsedAddr.name, parsedAddr.phone, parsedAddr.address].filter(s => s).join(',') || addrText

            // 获取 computer_code
            let computer_code = until.getCookie("guid").substring(0, 6)
            this.$toast.loading({ message: '准备提交...', duration: 0 })

            try {
                this.submitting = true
                let successCount = 0
                let failMessages = []

                // 循环提交每个产品/物料，每次提交都需要新的 salt
                for (let i = 0; i < this.selectedItems.length; i++) {
                    let item = this.selectedItems[i]
                    this.$toast.loading({ message: `提交 ${i + 1}/${this.selectedItems.length}...`, duration: 0 })

                    // 每次提交前获取新的 salt
                    let saltRes = await studio_tool_api.ToolForm_saltGet({ computer_code })
                    if (saltRes.errcode !== 0 || !saltRes.other) {
                        failMessages.push(`${item.name}: 获取salt失败`)
                        continue
                    }
                    let salt = saltRes.other

                    let submitData = {
                        app_id: this.$root.app_id,
                        computer_code,
                        salt,
                        shipment_type: this.currentType || 'product',
                        record_id: parseInt(item.id),
                        shipment_num: parseInt(item.shipment_num),
                        studio_id: parseInt(this.formData.studio_id),
                        sale_user_id: parseInt(this.formData.sale_user_id),
                        stock_code: parseInt(this.formData_stock_code),
                        shipment_address_info,
                        remark: this.formData.remark || ''
                    }

                    try {
                        let res = await studio_api.Teaching_studio_apiIotmaxShipmentAddPost(submitData)
                        if (res.errcode === 0) {
                            successCount++
                        } else {
                            failMessages.push(`${item.name}: ${res.errmsg || '提交失败'}`)
                        }
                    } catch (e) {
                        failMessages.push(`${item.name}: 网络错误`)
                    }
                }

                this.$toast.clear()
                this.submitting = false

                if (failMessages.length === 0) {
                    this.$toast.success(`成功提交 ${successCount} 项发货记录`)
                    this.close()
                    this.$emit('success')
                } else if (successCount > 0) {
                    this.$toast(`部分成功: ${successCount}项成功, ${failMessages.length}项失败`)
                    this.close()
                    this.$emit('success')
                } else {
                    this.$toast('提交失败: ' + failMessages.join('; '))
                }
            } catch (e) {
                this.$toast.clear()
                this.submitting = false
                console.error('提交失败', e)
                this.$toast('提交失败')
            }
        },

        close() {
            this.visible = false
        },

        onClose() {
            this.$emit('input', false)
        }
    }
}
</script>

<style scoped>
.shipment_dialog {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #f6f6f6;
}

.dialog_header {
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    background: #fff;
    flex-shrink: 0;
}

.dialog_title {
    font-size: 32px;
    font-weight: bold;
    color: #333;
}

.dialog_scrollable {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

/* 发货类型切换 */
.type_switch_row {
    display: flex;
    gap: 16px;
    padding: 16px 20px 8px;
    flex-shrink: 0;
}

.type_btn {
    font-size: 28px;
    color: #666;
    padding: 10px 32px;
    border-radius: 24px;
    background: #f0f0f0;
    border: 2px solid transparent;
    transition: all 0.2s;
    font-weight: 500;
}

.type_btn.active {
    background: rgba(78, 137, 255, 0.1);
    color: #4E89FF;
    border-color: #4E89FF;
    font-weight: 600;
}

.dialog_form {
    padding: 0 20px;
}

/* 仓库切换行 */
.warehouse_row {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
    gap: 16px;
}

.wh_label {
    font-size: 28px;
    color: #333;
    flex-shrink: 0;
    font-weight: 500;
}

.wh_tags {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.wh_btn {
    font-size: 26px;
    color: #666;
    padding: 8px 20px;
    border-radius: 20px;
    background: #f5f5f5;
    border: 2px solid transparent;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
}

.wh_btn b {
    font-size: 18px;
    color: #4E89FF;
}

.wh_btn.active {
    background: rgba(78, 137, 255, 0.1);
    color: #4E89FF;
    border-color: #4E89FF;
    font-weight: 600;
}

.selected_items {
    padding: 16px 20px 0;
}

.sel_title {
    font-size: 24px;
    color: #4E89FF;
    font-weight: bold;
    margin-bottom: 10px;
}

.sel_list {
}

.sel_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #fff;
    border-radius: 10px;
    margin-bottom: 8px;
}

.sel_info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.sel_name {
    font-size: 26px;
    color: #333;
    font-weight: bold;
}

.sel_code {
    font-size: 22px;
    color: #999;
}

.sel_stock {
    font-size: 22px;
    color: #4CAF50;
    font-weight: 500;
}

.sel_stock_row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
}

.sel_wh {
    font-size: 20px;
    color: #666;
    background: #f0f5ff;
    padding: 1px 8px;
    border-radius: 4px;
}

.sel_qty {
    display: flex;
    align-items: center;
    gap: 12px;
}

.sel_remove {
    cursor: pointer;
    padding: 6px;
}

.add_item_row {
    margin: 12px 20px;
    padding: 16px;
    background: #fff;
    border: 2px dashed #4E89FF;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 26px;
    color: #4E89FF;
    flex-shrink: 0;
}

.dialog_footer {
    padding: 16px 20px;
    background: #fff;
    flex-shrink: 0;
    box-shadow: 0 -2px 8px rgba(0,0,0,0.05);
}

/* 产品/物料选择器 */
.record_picker {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.picker_header {
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    border-bottom: 1px solid #f0f0f0;
    flex-shrink: 0;
}

.picker_header span {
    font-size: 32px;
    font-weight: bold;
    color: #333;
}

.record_list {
    flex: 1;
    overflow-y: auto;
    padding: 8px 20px;
}

.record_option {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 20px 16px;
    margin-bottom: 12px;
    background: #f8f9fa;
    border-radius: 12px;
    border: 2px solid transparent;
    transition: all 0.2s;
}

.record_option.checked {
    background: rgba(78, 137, 255, 0.08);
    border-color: #4E89FF;
}

.record_option.disabled {
    opacity: 0.5;
}

.ro_info {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
    min-width: 0;
}

.ro_img {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    position: relative;
    background: #f5f5f5;
}

.ro_img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.ro_img_count {
    position: absolute;
    bottom: 2px;
    right: 2px;
    background: rgba(0,0,0,0.55);
    color: #fff;
    font-size: 18px;
    padding: 1px 8px;
    border-radius: 6px;
    line-height: 1.4;
}

.ro_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.ro_name {
    font-size: 30px;
    color: #333;
    font-weight: 600;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ro_stock {
    font-size: 36px;
    font-weight: bold;
    color: #4E89FF;
    flex-shrink: 0;
    background: rgba(78, 137, 255, 0.08);
    padding: 2px 16px;
    border-radius: 8px;
}

.ro_stock.low {
    color: #F44336;
    background: rgba(244, 67, 54, 0.08);
}

.ro_stock.warn {
    color: #FF9800;
    background: rgba(255, 152, 0, 0.08);
}

.ro_code {
    font-size: 24px;
    color: #999;
}

.ro_warehouse {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 4px;
}

.ro_wh_tag {
    font-size: 22px;
    color: #555;
    background: #eef3ff;
    border: 1px solid rgba(78, 137, 255, 0.15);
    padding: 3px 12px;
    border-radius: 6px;
}

.ro_wh_tag b {
    font-weight: bold;
    margin-left: 4px;
}

.ro_no_stock {
    font-size: 22px;
    color: #F44336;
    margin-top: 4px;
    font-weight: 500;
}

.empty_records {
    text-align: center;
    padding: 60px 0;
    color: #ccc;
    font-size: 26px;
}

.picker_footer {
    padding: 16px 32px;
    border-top: 1px solid #f0f0f0;
    text-align: center;
    flex-shrink: 0;
    background: #fff;
}
</style>
